import {
  NavContainer,
  Logo,
  SearchContainer,
  User,
  Img,
  WishListContainer,
} from "./NavbarStyle";
import { AiOutlineSearch } from "react-icons/ai";
import { BsFillBookmarkCheckFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import axios from "axios";
import { useState } from "react";

const fetchProduct = async (key, search) => {
  return axios.get(
    `https://ancient-caverns-61891.herokuapp.com/api/v1/products/search/${search}`
  );
};

const NavbarElement = () => {
  const [search, setSearch] = useState("");

  // const { data, isLoading, isError, error, status } = useQuery(
  //   ["products", search],
  //   fetchProduct,
  //   {
  //     enabled: true,
  //   }
  // );

  // if (isLoading) return <h1>Loading...</h1>;
  // if (error) return <h1>{error}</h1>;

  // fetch and display the fetch results

  return (
    <NavContainer>
      <Logo></Logo>
      <SearchContainer onSubmit="refetch">
        <input
          type="text"
          placeholder="Search for products, brands and more"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </SearchContainer>
      <WishListContainer>
        <Link href="/wishlist">
          <BsFillBookmarkCheckFill color="#3cc830" />
          WishList
        </Link>
      </WishListContainer>

      <User>
        <Img></Img>

        <Link to="/login">Log in</Link>
      </User>
    </NavContainer>
  );
};

export default NavbarElement;
